import { render, staticRenderFns } from "./PopularityDoctorList.vue?vue&type=template&id=3f7d4d2e&scoped=true&"
import script from "./PopularityDoctorList.vue?vue&type=script&lang=js&"
export * from "./PopularityDoctorList.vue?vue&type=script&lang=js&"
import style0 from "./PopularityDoctorList.vue?vue&type=style&index=0&id=3f7d4d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7d4d2e",
  null
  
)

export default component.exports